import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Grid, Col } from 'components/grid'

import * as S from './styles'

const ICONS_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/security-fraud/icons`

const ReportScam: FC = memo(() => (
  <>
    <S.Section>
      <Grid col={{ phone: 1, tablet: 1, desktop: 12 }}>
        <Col col={{ desktop: 7 }} start={{ desktop: 2 }}>
          <Text as="h2" size="heading3" color="var(--colors-pink-text-default)" weight="medium">
            Como denunciar{' '}
            <Text as="span" size="heading3" color="var(--colors-neutral-text-default)" weight="medium">
              um golpe?
            </Text>
          </Text>
        </Col>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <Text color="var(--colors-neutral-text-weak)">
            A CashMe disponibiliza seus canais oficiais para a comunicação de atividades suspeitas e aplicações de golpe
            envolvendo o nome e imagem da empresa. Além disso, você deve acionar as autoridades legais sobre toda e
            qualquer tentativa de fraude.
          </Text>
          <S.ItemList>
            <Text color="var(--colors-neutral-text-weak)">Anote os canais de atendimento oficiais: </Text>
          </S.ItemList>
        </Col>
        <Col col={{ desktop: 7 }} start={{ desktop: 2 }}>
          <S.CardList>
            <S.Card>
              <S.CardHeading>
                <S.IconImage>
                  <NextImage
                    src={`${ICONS_PATH}/email-and-whatsapp.svg`}
                    alt="Desenho de um ícone de e-mail e ícone do whatsapp"
                    width="48"
                    height="48"
                    sizes="100vw"
                    style={{
                      width: '100%',
                      height: 'auto'
                    }}
                  />
                </S.IconImage>
                <Text as="h3" weight="bold" color="var(--colors-primary-background-strong-default)">
                  Canais de atendimento:
                </Text>
              </S.CardHeading>
              <S.ItemList>
                <ul className="disc">
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>Site:</b> www.cashme.com.br
                    </Text>
                  </li>
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>Telefone e Whatsapp:</b> (11) 4040-2550
                    </Text>
                  </li>
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>E-mail:</b> fale.conosco@cashme.com.br
                    </Text>
                  </li>
                </ul>
              </S.ItemList>
            </S.Card>
            <S.Card>
              <S.CardHeading>
                <S.IconImage>
                  <NextImage
                    src={`${ICONS_PATH}/phone-messages.svg`}
                    alt="Desenho de um telefone com diversas caixas de mensagem de texto"
                    width="48"
                    height="48"
                    sizes="100vw"
                    style={{
                      width: '100%',
                      height: 'auto'
                    }}
                  />
                </S.IconImage>
                <Text as="h3" weight="bold" color="var(--colors-primary-background-strong-default)">
                  Redes sociais:
                </Text>
              </S.CardHeading>
              <S.ItemList>
                <ul className="disc">
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>Instagram:</b> @cashmebrasil
                    </Text>
                  </li>
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>Youtube:</b> @cashmebrasil
                    </Text>
                  </li>
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>Facebook:</b> CashMeBrasil
                    </Text>
                  </li>
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>Linkedin:</b> CashMe
                    </Text>
                  </li>
                  <li>
                    <Text color="var(--colors-neutral-text-default)">
                      <b>TikTok:</b> cashme.brasil
                    </Text>
                  </li>
                </ul>
              </S.ItemList>
            </S.Card>
          </S.CardList>
        </Col>
      </Grid>
    </S.Section>
  </>
))

ReportScam.displayName = 'ReportScam'

export default ReportScam
